// extracted by mini-css-extract-plugin
export default {"menu":"Profile_menu__KcbVp","section":"Profile_section__bRR3p","sectionTitle":"Profile_sectionTitle__bRkFr","menuItem":"Profile_menuItem__210Sg","chevron":"Profile_chevron__LOfWY"};